<template>
  <v-dialog
    :width="width ? width : '550px'"
    v-model="visibility"
    :persistent="persistent"
  >
    <div class="modal-ui">
      <v-row no-gutters align="center" style="margin-bottom: 20px">
        <h2 class="modal-ui-title">
          {{ title }}
        </h2>
        <v-row no-gutters justify="end">
          <div class="closeIcon" @click="$emit('close')" />
        </v-row>
      </v-row>
      <slot />
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: "ModalUi",
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    width: {
      type: [String, Number],
      default: null,
    },
  },
  computed: {
    visibility: {
      get() {
        return this.visible;
      },
      set() {
        this.$emit("close");
      },
    },
  },
};
</script>

<style scoped>
.modal-ui {
  padding: 16px 20px;
  border-radius: 4px;
  background: #fafafa;
  color: #1d1d1d;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 19.6px;
  overflow-y: scroll;
}
.modal-ui-title {
  color: #1d1d1d;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
}
</style>
